/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { APPLICATION_VIEW_CORPORATE } from '@gh/builder-shared-data';
import { createRoute } from '@gh/builder-shared';
import { LicenseAgreementDetailsComponent } from './components/license-agreement-details/license-agreement-details.component';
import { LicenseAgreementListComponent } from './components/license-agreement-list/license-agreement-list.component';
import { LicenseAgreementDetailsBusinessService } from './resources/license-agreement-details-business.service';
import { LicenseAgreementListBusinessService } from './resources/license-agreement-list-business.service';

const routes = [
  createRoute({
    component: LicenseAgreementListComponent,
    init: LicenseAgreementListBusinessService,
    path: '',
    pathMatch: 'full',
    auth: {
      applicationView: [APPLICATION_VIEW_CORPORATE],
    },
  }),
  createRoute({
    component: LicenseAgreementDetailsComponent,
    path: 'new',
    leave: true,
    init: LicenseAgreementDetailsBusinessService,
    auth: {
      applicationView: [APPLICATION_VIEW_CORPORATE],
    },
  }),
  createRoute({
    component: LicenseAgreementDetailsComponent,
    path: ':licenseAgreementId',
    init: LicenseAgreementDetailsBusinessService,
    leave: true,
    auth: {
      applicationView: [APPLICATION_VIEW_CORPORATE],
    },
  }),
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class BuilderSetupLicenseAgreementsRoutingModule {
}
